import './App.scss';
import * as React from 'react';
import Loader from "./components/Loader/Loader";
import EmailForm from "./pages/EmailForm/EmailForm";
import UserInformationForm from "./pages/UserInformationForm/UserInformationForm";
import {FULL, REACHFIVE_FIELDS, UNKNOWN, getFieldValue} from "./utils/utils";
import Login from "./pages/Login/Login";
import Main from "./components/Main";
import download from "downloadjs";
import text from './utils/text';

interface Props {
    client: any,
    backend: string,
    origin?: string,
    email?: string,
    activityItemId: string,
    codeAction: string,
    downloadUrl?: string,
    thirdPartyUrl?: string,
    autofocus: boolean,
    account: boolean,
    rootElement: HTMLElement
}

interface State {
    email: string;
    loading: boolean
    logged: boolean,
    success?: boolean,
    invalidEmail: boolean,
    invalidEmailReason?: string,
    userStatus?: string
    fields: Array<string>;
    mustLogin: boolean;
    displayEmailMessage: boolean;
    displayLink: boolean;
}

export default class App extends React.Component<Props, State> {

    state: State  = {
        email: '',
        loading: true,
        logged: false,
        invalidEmail: false,
        mustLogin: false,
        fields: [],
        displayEmailMessage: true,
        displayLink: false,
    };

    componentDidMount() {
        this.props.client
            .checkSession()
            .then((session: any) => {
                fetch(
                    this.props.backend + '/api/origin/' + this.props.origin + '/user/jwt',
                    {
                        method: 'POST',
                        body: session.idToken,
                        credentials: 'include'
                    }
                )
                    .then(res => res.json())
                    .then((data) => {
                        this.setState({
                            email: data.email,
                            loading: false,
                            userStatus: data.status,
                            fields: data.missingFields,
                            logged: true
                        });
                    })
            })
            .catch((err: any) => {
                if(this.props.email){
                    this.handleEmailSubmit(this.props.email);
                } else {
                    this.setState({
                        loading: false,
                        logged: false
                    });
                }
            });
    }

    handleEmailSubmit(email: string) {
        this.setState({loading: true});
        if (this.props.rootElement) {
            this.props.rootElement.dispatchEvent(new Event('emailFilled'));
        }

        fetch(
          this.props.backend + '/api/origin/' + this.props.origin + '/user/email/' + email.replace('+','%2B') + '?' + new URLSearchParams({redirectUrl: window.location.href}),
          {
            credentials: 'include'
          })
            .then(res => res.json())
            .then((data) => {
                this.setState({ invalidEmail: false, invalidEmailReason: undefined });

                if(data.status === UNKNOWN){

                  var form = new FormData();
                  form.append('email', email);

                  // comment email check
                  // this.setState({email: email, loading: false, userStatus: data.status, fields: REACHFIVE_FIELDS });

                  fetch(this.props.backend + '/api/email/check', {
                    method: "POST",
                    body: form,
                    credentials: 'include'
                  })
                  .then((res) => {
                    if (res.ok) {
                      this.setState({email: email, loading: false, userStatus: data.status, fields: REACHFIVE_FIELDS });
                    } else {
                      this.setState({email: email, loading: false, userStatus: data.status, invalidEmail: true, invalidEmailReason: text.invalid_mail })
                    }

                    return res.json()
                  })
                  .then((data) => {
                    if (data.state && data.state === 'disposable') {
                      this.setState({invalidEmailReason: text.invalid_mails});
                    }
                  })
                }else{
                    this.setState({email, loading: false, userStatus: data.status, fields: data.missingFields });
                    if(data.status === FULL && this.props.account){
                        this.setState({ mustLogin: true });
                    }
                }
            })
    }
    handleInformationSubmit(datas: any) {
        this.setState({ loading: true });
        for (const field in datas) {
            datas[field]=getFieldValue(field,datas[field]);
        }

        datas['context'] = {
            'activityItemId': this.props.activityItemId,
            'codeAction': this.props.codeAction,
            'downloadUrl': this.props.downloadUrl,
            'thirdPartyUrl': this.props.thirdPartyUrl
        }

        fetch(
            this.props.backend + '/api/origin/' + this.props.origin + '/user/email/' + this.state.email.replace('+','%2B'),
            {
                    method: 'POST',
                    body: JSON.stringify(datas),
                    headers: { 'Content-Type': 'application/json', 'referer': window.location.href },
                    credentials: 'include'
                }
            )
            .then((res) => {
                if (res.ok) {
                    this.setState({ loading: false, success: true });
                } else {
                    this.setState({ loading: false, success: false });
                }
                return res.json();
            })
            .then((data) => {
                // this.state.userStatus == 'FULL' &&  // this check is on backend
                if (data.directDl) {
                    this.setState({ displayEmailMessage: false,  displayLink: true });
                    if (this.props.downloadUrl) {
                        download(this.props.downloadUrl);
                    } else if (this.props.thirdPartyUrl) {
                        window.open(this.props.thirdPartyUrl, '_blank');
                    }
                    if(this.props.rootElement) {
                        this.props.rootElement.dispatchEvent(new Event('directDownload'));
                    }
                } else {
                    if (this.props.rootElement) {
                        this.props.rootElement.dispatchEvent(new Event('indirectDownload'));
                    }
                }
            })
            .catch((error) => {
                this.setState({ loading: false, success: false });
            });
    }

    handleLoginOK() {
        // nothing redirect after login will append
    }

    handleResetEmail() {
        // do not really logout on reachfive, just clean form
        // if (this.state.logged) {
        //     this.props.client.logout()
        // }

        this.setState({
            email: '',
            userStatus: undefined,
            loading: false,
            logged: false,
            invalidEmail: false,
            mustLogin: false,
            fields: []
        });
    }

    public render() {
        const title = this.props.thirdPartyUrl ? text.see_content : text.dl_document;
        const globalClass = this.props.origin ?? '';
        if (this.state.loading) {
            return (
                <Main className={globalClass} title={title}>
                    <div className="text-center">
                        <Loader/>
                    </div>
                </Main>
            );
        }

        if (!this.state.userStatus || this.state.invalidEmail) {
            return (
                <Main className={globalClass} title={title}>
                    <EmailForm
                        email={this.props.email}
                        handleSubmit={(email) => this.handleEmailSubmit(email) }
                        error={this.state.invalidEmail}
                        errorMessage={this.state.invalidEmailReason}
                        submitText="Valider"
                        autofocus={this.props.autofocus}
                    />
                </Main>
            );
        }

        if (this.state.mustLogin) {
            return (
                <Main className={globalClass} title={title}>
                    <Login
                        reach5={ this.props.client }
                        backend={ this.props.backend }
                        email={ this.state.email }
                        handleSubmit={ this.handleLoginOK }
                        handleResetEmail={ () => this.handleResetEmail() }
                    />
                </Main>
            );
        }

        if (this.state.success) {
            const messageEmailSuccess = this.props.downloadUrl ?
                text.mail_for_free_dl: text.mail_for_third_party_dl;


            const dlLink = <a href={this.props.downloadUrl || this.props.thirdPartyUrl} target="_blank" rel="noreferrer">cliquez ici</a>;

            let messageLink = <span>{text.request_received}</span>;
            if (this.state.displayLink){
                const waitingText = this.props.downloadUrl ? text.wait_for_dl : text.wait_new_tab;
                messageLink = <span>{waitingText}{dlLink}.</span>;
            }

            return (
                <Main className={globalClass} title={title}>
                    <div className="gl-success-container">
                      <div>
                        <img src='https://getlead-preprod.editions-tissot.fr/success.svg' alt='Success' />
                      </div>
                      <div className="gl-success-message">
                        <p className='larger'>{messageLink}</p>
                        {this.state.displayEmailMessage && <p>{messageEmailSuccess}</p>}
                      </div>
                    </div>
                </Main>
            );
        }
        if (this.state.success === false) {
          console.error(text.dl_error);

          return (
                <Main className={globalClass} title={title}>
                    <div className="text-center">
                        <p className='larger'>{text.dl_error}</p>
                     </div>
                </Main>
            );
        }
        let label = 'Recevoir par email';
        if (this.state.userStatus === FULL){
            label = this.props.downloadUrl ? 'Télécharger' : 'Valider';
        }
        return (
            <Main className={globalClass} title={title}>
                <UserInformationForm
                    handleSubmit={(email) => this.handleInformationSubmit(email) }
                    email={ this.state.email }
                    emailUpdate={ this.state.userStatus !== FULL }
                    handleResetEmail={ () => this.handleResetEmail() }
                    fields={ this.state.fields }
                    logged={ this.state.logged }
                    buttonLabel={label}
                />
            </Main>
        );
    }
}
